import { AttributeShelf, FetchShelf } from "../../shelves";
import { makeAutoObservable } from "mobx";
import type { apiTypes } from "../../services";
import { api } from "../../services";
import type { AuthenticationStore } from "../../stores";

export class Store {
	public loginToken = new AttributeShelf<string | null>(null);
	public fraudAnalysisFetch: FetchShelf<apiTypes.APIResponse<apiTypes.FraudAnalysis>>;
	public fraudAnalysis = new AttributeShelf<apiTypes.FraudAnalysis | null>(null);

	constructor(public authStore: AuthenticationStore) {
		this.fraudAnalysisFetch = new FetchShelf(
			async () => api.getFraudAnalysis(authStore.getToken() || ""),
			(response) => {
				this.fraudAnalysis.set(response.data);
			},
		);

		makeAutoObservable(this);
	}
}
